import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.default};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
`;

export const $ProductHeader = styled.div`
  padding: ${spacing('xl')} ${spacing('xxl')};
  color: ${({ theme }) => theme.colors.mainTextColor};
`;

export const $ProductBillingNumber = styled.div`
  span:first-child {
    font-weight: bold;
  }
`;

export const $ProductSkeletonRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${spacing('xl')} ${spacing('lg')};
  border-top: ${spacing('px')} solid ${({ theme }) => theme.colors.disabled};
`;
